import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/station_comments',
  component: Management,
  redirect: '/station_comments/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/station_comments/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listStationComments
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/station_comments/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/station_comments/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'pending'
          }
        },
        {
          path: 'passed',
          component: () => import('@/views/station_comments/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'passed'
          }
        },
        {
          path: 'rejected',
          component: () => import('@/views/station_comments/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'rejected'
          }
        }
      ]
    }
  ]
}
